import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

export const initialState = {
	currentContextUser: null,
};

const taskOverviewUserContextReducer = {
	[types.SET_TASK_OVERVIEW_CONTEXT_USER]: (state, action) => ({
		currentContextUser: action.payload,
	}),

	[types.RESET_TASK_OVERVIEW_CONTEXT_USER]: () => {
		return initialState;
	},
};

export default handleActions(taskOverviewUserContextReducer, initialState);
